import { createAction, props } from '@ngrx/store';
import { User } from '../../core/models/auth.interface';

export const login = createAction(
  '[Auth] Login',
  props<{ accessToken: string; refreshToken: string }>()
);

export const loginSuccess = createAction(
  '[Auth] Login Success',
  props<{ user: User; accessToken: string; refreshToken: string }>()
);

export const loginFailure = createAction(
  '[Auth] Login Failure',
  props<{ error: any }>()
);

export const logout = createAction('[Auth] Logout');

export const setUser = createAction(
  '[Auth] Set User',
  props<{ user: User }>()
);
